import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const { FiTarget, FiPlus, FiHome, FiBookOpen } = FiIcons;

function Header() {
  const location = useLocation();

  return (
    <motion.header 
      className="bg-white shadow-sm border-b border-gray-200"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container mx-auto px-4 py-4 max-w-7xl">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="bg-purple-600 p-2 rounded-lg group-hover:bg-purple-700 transition-colors">
              <SafeIcon icon={FiTarget} className="text-white text-xl" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                Clarity <span className="text-purple-600">Ecosystem</span>
              </h1>
              <p style={{
      color: 'rgb(75, 85, 99)'
    }} className="text-sm text-gray-600">Measure progress in your foundational work</p>
            </div>
          </Link>
          
          <nav className="flex items-center space-x-2">
            <Link 
              to="/" 
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                location.pathname === '/' 
                  ? 'bg-purple-50 text-purple-700' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <SafeIcon icon={FiHome} className="text-lg" />
              <span className="font-medium">Dashboard</span>
            </Link>
            
            <Link 
              to="/systems-guide" 
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                location.pathname === '/systems-guide' 
                  ? 'bg-purple-50 text-purple-700' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <SafeIcon icon={FiBookOpen} className="text-lg" />
              <span className="font-medium">Systems Guide</span>
            </Link>
            
            <Link 
              to="/new-entry" 
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                location.pathname === '/new-entry' 
                  ? 'bg-green-50 text-green-700' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <SafeIcon icon={FiPlus} className="text-lg" />
              <span className="font-medium">New Entry</span>
            </Link>
          </nav>
        </div>
      </div>
    </motion.header>
  );
}

export default Header;